/**
 * O que faz: Calcula a visualização da distribuição semanal a partir do agregado recebido.
 * Onde usa: Card "Distribuição por Dia da Semana" e relatório do dashboard.
 * Conexões: SemanaDashboard, Button/filtros locais do dashboard.
 * Tabelas: Nenhuma; só transforma dados já agregados pelo serviço.
 * Data: 30/08/2026.
 */

import type { SemanaDashboard } from './dashboardContracts';

const DIAS_DA_SEMANA = [
  ['Domingo', 'Dom'],
  ['Segunda', 'Seg'],
  ['Terça', 'Ter'],
  ['Quarta', 'Qua'],
  ['Quinta', 'Qui'],
  ['Sexta', 'Sex'],
  ['Sábado', 'Sáb'],
] as const;

export type FiltroSemanaDashboard = 'todos' | 'anuncios';

export interface ItemSemanaDashboard {
  dia: string;
  nomeCurto: string;
  leads: number;
  percentual: number;
}

export interface ResultadoSemanaDashboard {
  total: number;
  itens: ItemSemanaDashboard[];
}

export const selecionarSemana = (
  semana: SemanaDashboard[],
  filtro: FiltroSemanaDashboard,
): ResultadoSemanaDashboard => {
  const contagens = Array.from({ length: 7 }, (_, indice) => {
    // O fallback zero mantém os sete dias visíveis mesmo quando o banco não teve ocorrência.
    const item = semana.find(ponto => ponto.dia === indice);
    return item?.[filtro] ?? 0;
  });
  const total = contagens.reduce((soma, valor) => soma + valor, 0);

  return {
    total,
    itens: contagens.map((leads, indice) => ({
      dia: DIAS_DA_SEMANA[indice][0],
      nomeCurto: DIAS_DA_SEMANA[indice][1],
      leads,
      // O percentual usa o recorte escolhido; usar o total geral faria o filtro parecer inconsistente.
      percentual: total > 0 ? Math.round((leads / total) * 1000) / 10 : 0,
    })),
  };
};
